<template>
    <div class="row">
        <div class="col-lg-6 mb-1 mb-lg-0">
            <div class="border rounded px-1 pt-1 mb-1">
                <div class="row">
                    <div class="col-12 mb-1">
                        <label class="form-label">Ücret Nevi</label>
                        <div>
                            <b-form-radio disabled v-model="un" inline value="A">Aylık</b-form-radio>
                            <b-form-radio disabled v-model="un" inline value="G">Günlük</b-form-radio>
                            <b-form-radio disabled v-model="un" inline value="S">Saatlik</b-form-radio>
                        </div>
                    </div>
                    <div class="col-lg-6 col-12">
                        <label class="form-label">Brüt Ücreti</label>
                        <input type="text" disabled class="form-control" :value="sgkSalary.IsMinimumWage ? sgkSalary.SalaryStr : null"  placeholder="Brüt Ücreti" />
                    </div>
                    <div class="col-lg-6 col-12">
                        <label class="form-label">Net Ücreti</label>
                        <input type="text" disabled class="form-control" :value="sgkSalary.IsMinimumWage ? null : sgkSalary.SalaryStr" placeholder="Net Ücreti" />
                    </div>
                    <div class="col-12 mb-1">
                        <label class="form-label"></label>
                        <b-form-checkbox value="E" v-model="value.NETTENGIT" unchecked-value="H">Net Ücretten Anlaşma</b-form-checkbox>
                    </div>
                    <!-- <div class="col-lg-3 col-md-6 col-12 mb-1">
                        <label class="form-label">Döviz Cinsi</label>
                        <v-select-list :options="currencies" placeholder="Döviz Cinsi" v-model="currency" label="Name"></v-select-list>
                    </div>
                    <div class="col-lg-3 col-md-6 col-12 mb-1">
                        <label class="form-label">Döviz Ücreti</label>
                        <input type="number" class="form-control" placeholder="Döviz Ücreti" />
                    </div> -->
                </div>
            </div>
            <div class="row">
                <div class="col-lg-6 col-12 mb-1">
                    <label class="form-label">Hesap Kodu</label>
                    <v-select-list :options="hesapList" v-model="hesap" placeholder="Hesap Kodu"></v-select-list>
                </div>  
                <div class="col-lg-6 col-12 mb-1">
                    <label class="form-label">SGK Durum</label>
                    <v-select-list :options="sgkDurums" v-model="sgkDurum" placeholder="SGK Durum" label="Description"></v-select-list>
                </div>  
                <div class="col-12 mb-1">
                    <label class="form-label">SGK B. Türü</label>
                    <v-select-list :options="sgkBTurus" v-model="sgkBTuru" placeholder="SGK B. Türü" label="Description"></v-select-list>
                </div>  
                <div class="col-lg-6 col-12 mb-1">
                    <label class="form-label">Fiili Hiz. SBT</label>
                    <v-select-list :options="fiiliHizmetSBTMs" v-model="fiiliHizmetSBTM" placeholder="Fiili Hiz. SBT" label="Description"></v-select-list>
                </div>  
                <div class="col-lg-6 col-12 mb-1">
                    <label class="form-label">SGK Kanun</label>
                    <input class="form-control" placeholder="SGK Kanun" v-model="value.SICSSKKANUN" />
                </div>
                <div class="col-lg-6 col-12 mb-1">
                    <label class="form-label">Emeklilik Tarihi</label>
                    <v-date-picker placeholder="Emeklilik Tarihi" v-model="value.EMEKLILIK_TARIHI"></v-date-picker>
                </div>
                <div class="col-lg-6 col-12 mb-1">
                    <label class="form-label">Doğrudan Gider</label>
                    <input class="form-control" type="mumber" placeholder="Doğrudan Gider" v-model="value.DOGRUDANGIDER" />
                </div>
                <div class="col-lg-6 col-12 mb-1">
                    <label class="form-label">Asgari Geçim İndirim Oranı (%)</label>
                    <input class="form-control" type="mumber" placeholder="Asgari Geçim İndirim Oranı" v-model="value.ASGGV_IND" />
                </div>
                <div class="col-lg-6 col-12 mb-1">
                    <label class="form-label">Asgari Geçim İnd. Dahil Çocuk Sayısı</label>
                    <input class="form-control" type="mumber" placeholder="Asgari Geçim İnd. Dahil Çocuk Sayısı" v-model="value.ASGDV_IND" />
                </div>
                <div class="col-12 mb-1">
                    <label class="form-label">İşçi/Memur</label>
                    <div>
                        <b-form-radio inline v-model="value.ISCI_MEMUR" value="I">İşçi</b-form-radio>
                        <b-form-radio inline v-model="value.ISCI_MEMUR" value="M">Memur</b-form-radio>
                    </div>
                </div>
                <div class="col-12 mb-1">
                    <div class="border rounded p-1">
                        <b-form-checkbox class="mb-50" value="E" unchecked-value="H" v-model="value.IND_DILEK">İndirim Dilekçesi</b-form-checkbox>
                        <b-form-checkbox class="mb-50" value="1" unchecked-value="0" v-model="value.ESKIHUKUMLU">Eski Hükümlü</b-form-checkbox>
                        <b-form-checkbox class="mb-50" value="E" unchecked-value="H" v-model="value.GOCMEN">Göçmen</b-form-checkbox>
                        <b-form-checkbox value="1" unchecked-value="0" v-model="value.TERORLEMUCADELE">Terörle Mücedale Kapsamlı</b-form-checkbox>
                    </div>
                </div>
                <div class="col-12 mb-1">
                    <div class="border rounded px-1 pt-1">
                        <div class="row">
                            <div class="col-lg-6 mb-1">
                                <label>Sakatlık Dercesi</label>
                                <select class="form-control" v-model="value.SAKATLIK_DRC">
                                    <option v-for="s in sakatliks" :key="s.value" :value="s.value">{{s.text}}</option>
                                </select>
                            </div>
                            <div class="col-lg-6 mb-1">
                                <label>1.Drc Sakat Yakın</label>
                                <input type="number" class="form-control" v-model="value.DERECE1_YAKIN_SAYISI" placeholder="1.Drc Sakat Yakın"/>
                            </div>
                            <div class="col-lg-6 mb-1">
                                <label>2.Drc Sakat Yakın</label>
                                <input type="number" class="form-control" v-model="value.DERECE2_YAKIN_SAYISI" placeholder="1.Drc Sakat Yakın"/>
                            </div>
                            <div class="col-lg-6 mb-1">
                                <label>3.Drc Sakat Yakın</label>
                                <input type="number" class="form-control" v-model="value.DERECE3_YAKIN_SAYISI" placeholder="1.Drc Sakat Yakın"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 col-12 mb-1">
                    <label class="form-label">Kıdem Gününe Dahil/Hariç Gün Sayısı (+/-)</label>
                    <input type="number" v-model="value.EKKIDEMGUNSAY" placeholder="Kıdem Gününe Dahil/Hariç Gün Sayısı (+/-)" class="form-control"/>
                </div>
                <div class="col-lg-6 col-12 mb-1">
                    <label class="form-label">Bordro Zarfı Şifresi</label>
                    <input v-model="value.SICBORDRO_SIFRE" placeholder="Bordro Zarfı Şifresi" class="form-control"/>
                </div>
                <div class="col-lg-12 col-12 mb-1">
                    <b-form-checkbox value="E" unchecked-value="null" v-model="value.S_YEDEK2">İstisnaya Dahil</b-form-checkbox>
                </div>
            </div>
        </div>
        <div class="col-lg-6">
            <div class="border rounded px-1 pt-1 mb-1">
                <h3 class="font-weight-bolder text-primary">Çocuklar</h3>
                <div class="row">
                    <div class="col-lg-6 col-12 mb-1">
                        <label class="form-label">Çocuk Adedi</label>
                        <input class="form-control" v-model="value.COCUK_ADEDI" type="number" placeholder="Çocuk Adedi"/>
                    </div>
                    <div class="col-lg-6 col-12 mb-1">
                        <label class="form-label">Okul Öncesi</label>
                        <input class="form-control" v-model="value.OKUL_ONCESI_COCUK" type="number" placeholder="Okul Öncesi"/>
                    </div>
                    <div class="col-lg-6 col-12 mb-1">
                        <label class="form-label">İlkokul</label>
                        <input class="form-control" v-model="value.ILKOKUL_COCUK" type="number" placeholder="İlkokul"/>
                    </div>
                    <div class="col-lg-6 col-12 mb-1">
                        <label class="form-label">Orta</label>
                        <input class="form-control" v-model="value.ORTA_COCUK" type="number" placeholder="Orta"/>
                    </div>
                    <div class="col-lg-6 col-12 mb-1 mb-lg-0">
                        <label class="form-label">Lise</label>
                        <input class="form-control" v-model="value.LISE_COCUK" type="number" placeholder="Lise"/>
                    </div>
                    <div class="col-lg-6 col-12">
                        <label class="form-label">Yüksek</label>
                        <input class="form-control" v-model="value.YUKSEK_COCUK" type="number" placeholder="Yüksek"/>
                    </div>
                </div>
                <hr/>
                <h5 class="font-weight-bolder text-secondary">SGK'dan Muaf</h5>
                <div class="row">
                    <div class="col-lg-6 col-12 mb-1">
                        <label class="form-label">Çocuk Adedi</label>
                        <input class="form-control" v-model="value.SSK_COCUK_ADEDI" type="number" placeholder="Çocuk Adedi"/>
                    </div>
                    <div class="col-lg-6 col-12 mb-1">
                        <label class="form-label">Okul Öncesi</label>
                        <input class="form-control" v-model="value.SSK_OKUL_ONCESI_COCUK" type="number" placeholder="Okul Öncesi"/>
                    </div>
                    <div class="col-lg-6 col-12 mb-1">
                        <label class="form-label">İlkokul</label>
                        <input class="form-control" v-model="value.SSK_ILKOKUL_COCUK" type="number" placeholder="İlkokul"/>
                    </div>
                    <div class="col-lg-6 col-12 mb-1">
                        <label class="form-label">Orta</label>
                        <input class="form-control" v-model="value.SSK_ORTA_COCUK" type="number" placeholder="Orta"/>
                    </div>
                    <div class="col-lg-6 col-12 mb-1 mb-lg-0">
                        <label class="form-label">Lise</label>
                        <input class="form-control" v-model="value.SSK_LISE_COCUK" type="number" placeholder="Lise"/>
                    </div>
                    <div class="col-lg-6 col-12">
                        <label class="form-label">Yüksek</label>
                        <input class="form-control" v-model="value.SSK_YUKSEK_COCUK" type="number" placeholder="Yüksek"/>
                    </div>
                </div>
                <hr/>
                <h5 class="font-weight-bolder text-secondary">GV'den Muaf</h5>
                <div class="row">
                    <div class="col-lg-6 col-12 mb-1">
                        <label class="form-label">Çocuk Adedi</label>
                        <input class="form-control" v-model="value.GV_COCUK_ADEDI" type="number" placeholder="Çocuk Adedi"/>
                    </div>
                    <div class="col-lg-6 col-12 mb-1">
                        <label class="form-label">Okul Öncesi</label>
                        <input class="form-control" v-model="value.GV_OKUL_ONCESI_COCUK" type="number" placeholder="Okul Öncesi"/>
                    </div>
                    <div class="col-lg-6 col-12 mb-1">
                        <label class="form-label">İlkokul</label>
                        <input class="form-control" v-model="value.GV_ILKOKUL_COCUK" type="number" placeholder="İlkokul"/>
                    </div>
                    <div class="col-lg-6 col-12 mb-1">
                        <label class="form-label">Orta</label>
                        <input class="form-control" v-model="value.GV_ORTA_COCUK" type="number" placeholder="Orta"/>
                    </div>
                    <div class="col-lg-6 col-12 mb-1">
                        <label class="form-label">Lise</label>
                        <input class="form-control" v-model="value.GV_LISE_COCUK" type="number" placeholder="Lise"/>
                    </div>
                    <div class="col-lg-6 col-12 mb-1">
                        <label class="form-label">Yüksek</label>
                        <input class="form-control" v-model="value.GV_YUKSEK_COCUK" type="number" placeholder="Yüksek"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { BTab,BTabs,BFormRadio,BFormCheckbox } from 'bootstrap-vue'
import HRNetsisApi from '@/api/hr-netsis'
import SystemDataApi from '@/api/system-data'

export default {
    components:{
        BTabs,
        BTab,
        BFormRadio,
        BFormCheckbox
    },
    props:{
        aktifNetsisSube:String,
        sgkSalary:Object,
        value:Object,
        id:[String,Number],
        getPersonal:Function,
        branch:Object
    },
    data(){
        return{
            hesapList:[],
            sgkDurums:[],
            sgkBTurus:[],
            currencies:[],
            fiiliHizmetSBTMs:[],
            sakatliks:[
                {text:'0. Yok',value:0},
                {text:'1. Derece',value:1},
                {text:'2. Derece',value:2},
                {text:'3. Derece',value:3}
            ],
            types:[]
        }
    },
    watch:{
        aktifNetsisSube(oldV,newV){
            if(oldV != newV) this.getHesapList()
        }
    },  
    mounted(){
        console.log(this.value)
        this.getHesapList()
        this.getSgkDurums()
        this.getSgkBTurus()
        this.getFiiliHizmetSBTMs()
        this.getCurrencyUnits()
        this.getSalaryTypes()
    },
    methods:{
        getHesapList(){
            debugger;
                HRNetsisApi.HesapListAll().then(res=>{
                    debugger;
                    this.hesapList = res.data.Data
                })
        },
        getCurrencyUnits(){
            SystemDataApi.CurrencyUnit().then(res=>{
                this.currencies = res.data.Data
            })
        },
        getSgkDurums(){
            HRNetsisApi.SGKDurum().then(res=>{
                this.sgkDurums = res.data
            })
        },
        getSgkBTurus(){
            HRNetsisApi.SGKBTuru().then(res=>{
                this.sgkBTurus = res.data
            })
        },
        getFiiliHizmetSBTMs(){
            HRNetsisApi.FiiliHizmetSBTM().then(res=>{
                this.fiiliHizmetSBTMs = res.data
            })
        },
        getSalaryTypes(){
            SystemDataApi.SalaryType().then(res=>{
                this.types = res.data.Data
            })
        },
    },
    computed:{
        un:{
            get:function(){
                return this.sgkSalary.UCRET_NEVI
            },
            set:function(){
                
            }
        },
        hesap:{
            get:function(){
                return this.hesapList.find(i=>i==this.value.HESAPKODU)
            },
            set:function(value){
                this.value.HESAPKODU = value || null
            }
        },
        sgkDurum:{
            get:function(){
                return this.sgkDurums.find(i=> i.Value==this.value.SSK_DURUM)
            },
            set:function(value){
                this.value.SSK_DURUM = value?.Value || null
            }
        },
        sgkBTuru:{
            get:function(){
                return this.sgkBTurus.find(i=> i.Value==this.value.SICSSKBELGE)
            },
            set:function(value){
                this.value.SICSSKBELGE = value?.Value || null
            }
        },
        fiiliHizmetSBTM:{
            get:function(){
                return this.fiiliHizmetSBTMs.find(i=> i.Value==this.value.TAS_HESNO)
            },
            set:function(value){
                this.value.TAS_HESNO = value?.Value || null
            }
        },
        currency:{
            get:function(){
                return this.currencies.find(b=>b.Id==this.value.NetSalaryCurrencyUnitId)
            },
            set:function(value){
                this.value.NetSalaryCurrencyUnitId = value?.Id || null
            }
        },
        current(){
            if(this.branch){
                return this.branch?.Current?.Branch?.Name || null
            }
        }
    }
}
</script>

<style>

</style>